import { IContentPackageSection } from '@imcc/transport';

export const FEATURE_KEY = 'contentPackageSections';

export class SectionsState {
  [id: string]: IContentPackageSection;
}

export const initialState = {};
